import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderTariffDataSchema } from './ServicesProviderTariffData.js';

class ServicesProviderTariff extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderTariffDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderTariff.validation', `ServicesProviderTariff data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.TARIFF,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.TARIFF, ServicesProviderTariff);

export { ServicesProviderTariff };
//# sourceMappingURL=ServicesProviderTariff.js.map
